import { TransactionApprovalHistoryRequest, ApprovalHistoryItem } from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';
import vopayApi from '@/services/api.config';
const { api } = vopayApi;

export default function useTransactionApproval({ bearer }: { bearer?: string } = {}) {
  const source = axios.CancelToken.source();
  const [approvalHistory, setApprovalHistory] = useState<ApprovalHistoryItem[]>([]);

  useEffect(() => {
    return () => {
      source.cancel();
    };
  }, []);

  const fetchApprovalHistory = async (request: TransactionApprovalHistoryRequest) => {
    try {
      const res = await api.fetchTransactionApprovalHistory(request, bearer, source);
      if (!res.Success) throw new Error(res.ErrorMessage);

      setApprovalHistory(res.ApprovalHistory);
      return res;
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  return {
    approvalHistory,
    fetchApprovalHistory,
  };
}
